import {
	EnumHelperBase,
	EVENT_CATEGORY,
	eventCategoryEnumBase,
	type EventCategoryEnumBaseData,
	type EventCategoryEnumBaseExtraData,
} from '@nfctron/nexus-core';
import {
	BabyIcon,
	BeerIcon,
	CalendarRangeIcon,
	CastleIcon,
	ChefHatIcon,
	DramaIcon,
	MicVocalIcon,
	MusicIcon,
	PartyPopperIcon,
	TentIcon,
	TrophyIcon,
	WineIcon,
	type LucideIcon,
} from 'lucide-react';

export interface EventCategoryEnumReactExtraDataExtend {
	Icon: LucideIcon;
}

export interface EventCategoryEnumReactData extends EventCategoryEnumBaseData, EventCategoryEnumReactExtraDataExtend {}

/**
 * Event category enumeration with extra data for React
 * @extends EventCategoryEnumBase Base eventCategory enumeration
 */
class EventCategoryEnumReact extends EnumHelperBase<
	EventCategoryEnumBaseExtraData,
	EVENT_CATEGORY,
	typeof eventCategoryEnumBase.enumName,
	typeof eventCategoryEnumBase.idKey,
	EventCategoryEnumReactExtraDataExtend
> {
	constructor() {
		super(eventCategoryEnumBase.enumName, eventCategoryEnumBase.data, eventCategoryEnumBase.idKey, {
			[EVENT_CATEGORY.MUSIC]: { Icon: MusicIcon },
			[EVENT_CATEGORY.FOOD]: { Icon: ChefHatIcon },
			[EVENT_CATEGORY.CULTURE]: { Icon: CastleIcon },
			[EVENT_CATEGORY.WINE]: { Icon: WineIcon },
			[EVENT_CATEGORY.SPORT]: { Icon: TrophyIcon },
			[EVENT_CATEGORY.SERIES]: { Icon: CalendarRangeIcon },
			[EVENT_CATEGORY.FESTIVAL]: { Icon: TentIcon },
			[EVENT_CATEGORY.CHILDREN]: { Icon: BabyIcon },
			[EVENT_CATEGORY.PARTY]: { Icon: PartyPopperIcon },
			[EVENT_CATEGORY.THEATER]: { Icon: DramaIcon },
			[EVENT_CATEGORY.CONCERT]: { Icon: MicVocalIcon },
			[EVENT_CATEGORY.BEER]: { Icon: BeerIcon },
		});
	}
}

export const eventCategoryEnumReact = new EventCategoryEnumReact();
